//import React from "react";

function Dashboard() {
  return (
    <div className="bg-dark text-light min-vh-100">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-black shadow">
        <div className="container">
          <a className="navbar-brand fw-bold" href="#">
            M Technology
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="#about">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#services">
                  Services
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="text-center py-5 bg-dark">
        <div className="container">
          <h1 className="display-4 fw-bold">Welcome to M Technology</h1>
          <p className="lead text-secondary">
            We help businesses grow with innovative solutions.
          </p>
          <a href="#contact" className="btn btn-primary btn-lg mt-3">
            Get in Touch
          </a>
        </div>
      </header>

      {/* About Section */}
      <section id="about" className="py-5 bg-black">
        <div className="container text-center">
          <h2 className="fw-bold mb-4">About Us</h2>
          <p className="text-secondary">
            MyCompany is a leading provider of business solutions. Our mission
            is to deliver high-quality services that empower our clients to
            succeed in the digital age.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-5 bg-dark">
        <div className="container">
          <h2 className="fw-bold text-center mb-5">Our Services</h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card bg-black text-light h-100 shadow">
                <div className="card-body text-center">
                  <h5 className="card-title">Web Development</h5>
                  <p className="card-text text-secondary">
                    Custom websites and web apps tailored to your business.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card bg-black text-light h-100 shadow">
                <div className="card-body text-center">
                  <h5 className="card-title">Mobile Solutions</h5>
                  <p className="card-text text-secondary">
                    Innovative mobile applications for Android and iOS.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card bg-black text-light h-100 shadow">
                <div className="card-body text-center">
                  <h5 className="card-title">Consulting</h5>
                  <p className="card-text text-secondary">
                    Expert advice to help grow your business with technology.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-5 bg-black">
        <div className="container text-center">
          <h2 className="fw-bold mb-4">Contact Us</h2>
          <p className="text-secondary">
            Have a project in mind? Let's talk about it.
          </p>
          <a
            href="mailto:info@mycompany.com"
            className="btn btn-outline-light btn-lg"
          >
            Email Us
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-center py-3 border-top border-secondary">
        <p className="mb-0 text-secondary">
          © {new Date().getFullYear()} M Technology. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default Dashboard;
